/* ============================================================
   PRAISETHEHIGHEST — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     Mobile Menu
     ============================================================ */

  const menuToggle = document.querySelector('.site-header__hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuOverlay = document.getElementById('mobile-menu-overlay');
  const menuClose = document.querySelector('.mobile-menu__close');

  function openMenu() {
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuOverlay.style.display = 'block';
    setTimeout(() => menuOverlay.classList.add('is-visible'), 10);
    document.body.classList.add('no-scroll');
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuOverlay.classList.remove('is-visible');
    setTimeout(() => { menuOverlay.style.display = 'none'; }, 250);
    document.body.classList.remove('no-scroll');
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', openMenu);
  }
  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }
  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeMenu);
  }

  /* ============================================================
     Cart Notification
     ============================================================ */

  const cartNotification = document.getElementById('cart-notification');
  let cartTimer;

  function showCartNotification() {
    if (!cartNotification) return;
    cartNotification.setAttribute('aria-hidden', 'false');
    cartNotification.classList.add('is-visible');
    clearTimeout(cartTimer);
    cartTimer = setTimeout(() => {
      cartNotification.classList.remove('is-visible');
      cartNotification.setAttribute('aria-hidden', 'true');
    }, 3500);
  }

  /* ============================================================
     Cart API helpers
     ============================================================ */

  async function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!res.ok) throw new Error('Cart add failed');
      await res.json();
      updateCartCount();
      showCartNotification();
    } catch (err) {
      console.error(err);
    }
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const counts = document.querySelectorAll('.cart-count');
      counts.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch (err) {
      console.error(err);
    }
  }

  /* ============================================================
     Product Gallery
     ============================================================ */

  function initProductGallery() {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    const mainImg = gallery.querySelector('.product-gallery__main-image');
    const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.querySelector('img').src;
        const srcset = thumb.querySelector('img').srcset;
        if (mainImg) {
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
        }
      });
    });

    if (thumbs.length > 0) thumbs[0].classList.add('is-active');
  }

  /* ============================================================
     Variant Picker (Product Page)
     ============================================================ */

  function initVariantPicker() {
    const picker = document.querySelector('.variant-picker');
    if (!picker) return;

    const options = picker.querySelectorAll('.variant-picker__option');
    const addToCartBtn = document.querySelector('.product-form__add-to-cart');
    const priceEl = document.querySelector('.product-details__price');
    const variantInput = document.querySelector('[name="id"]');

    if (!options.length) return;

    // Get variants data from the page
    const variantsData = window.productVariants || [];

    options.forEach(opt => {
      opt.addEventListener('click', () => {
        if (opt.classList.contains('is-unavailable')) return;

        options.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        const selectedValue = opt.dataset.value;
        const selectedOption = opt.dataset.option;
        const matchingVariant = findMatchingVariant(variantsData, selectedValue, selectedOption);

        if (matchingVariant && variantInput) {
          variantInput.value = matchingVariant.id;
          updatePrice(matchingVariant, priceEl);
          updateAvailability(matchingVariant, addToCartBtn);
        }
      });
    });
  }

  function findMatchingVariant(variants, value, optionIndex) {
    const selectedOptions = getSelectedOptions();
    return variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i] || selectedOptions[i] === undefined)
    );
  }

  function getSelectedOptions() {
    const selected = [];
    const groups = document.querySelectorAll('[data-option-position]');
    groups.forEach(group => {
      const active = group.querySelector('.variant-picker__option.is-selected');
      if (active) selected.push(active.dataset.value);
    });
    return selected;
  }

  function updatePrice(variant, priceEl) {
    if (!priceEl || !variant) return;
    const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = `
        <span class="price--sale">${formatter.format(variant.price / 100)}</span>
        <span class="price--was">${formatter.format(variant.compare_at_price / 100)}</span>
      `;
    } else {
      priceEl.innerHTML = `<span>${formatter.format(variant.price / 100)}</span>`;
    }
  }

  function updateAvailability(variant, btn) {
    if (!btn) return;
    if (variant.available) {
      btn.disabled = false;
      btn.textContent = window.cartStrings.addToCart || 'Add to Cart';
    } else {
      btn.disabled = true;
      btn.textContent = window.cartStrings.soldOut || 'Sold Out';
    }
  }

  /* ============================================================
     Add to Cart — Product Form
     ============================================================ */

  function initProductForm() {
    const form = document.querySelector('.product-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;

      const btn = form.querySelector('.product-form__add-to-cart');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }

      await addToCart(variantId, quantity);

      if (btn && !btn.disabled) {
        btn.textContent = window.cartStrings.addToCart || 'Add to Cart';
      } else if (btn) {
        btn.disabled = false;
        btn.textContent = window.cartStrings.addToCart || 'Add to Cart';
      }
    });
  }

  /* ============================================================
     Quick Add (Product Cards)
     ============================================================ */

  function initQuickAdd() {
    const quickAddBtns = document.querySelectorAll('.product-card__quick-add');
    quickAddBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        await addToCart(variantId, 1);
        btn.textContent = 'Added!';
        setTimeout(() => {
          btn.textContent = btn.dataset.label || 'Quick Add';
          btn.disabled = false;
        }, 1500);
      });
    });
  }

  /* ============================================================
     Product Accordion
     ============================================================ */

  function initAccordion() {
    const items = document.querySelectorAll('.product-accordion__item');
    items.forEach(item => {
      const header = item.querySelector('.product-accordion__header');
      const body = item.querySelector('.product-accordion__body');
      if (!header || !body) return;

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        if (isOpen) {
          item.classList.remove('is-open');
          body.style.maxHeight = '0';
        } else {
          item.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    // Open first accordion by default
    if (items.length > 0) {
      const firstItem = items[0];
      const firstBody = firstItem.querySelector('.product-accordion__body');
      firstItem.classList.add('is-open');
      if (firstBody) firstBody.style.maxHeight = firstBody.scrollHeight + 'px';
    }
  }

  /* ============================================================
     Size Guide Modal
     ============================================================ */

  function initSizeGuide() {
    const trigger = document.querySelector('[data-size-guide]');
    const modal   = document.getElementById('SizeGuideModal');
    if (!trigger || !modal) return;

    const closeBtn  = modal.querySelector('.sg-modal__close');
    const backdrop  = modal.querySelector('.sg-modal__backdrop');

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function initQuantityStepper() {
    const stepper = document.querySelector('.product-qty__stepper');
    if (!stepper) return;
    const input = stepper.querySelector('.product-qty__value');
    const minusBtn = stepper.querySelector('[data-qty-change="-1"]');
    const plusBtn = stepper.querySelector('[data-qty-change="1"]');

    function updateButtons() {
      const val = parseInt(input.value, 10) || 1;
      minusBtn.disabled = val <= 1;
      plusBtn.disabled = val >= 10;
    }

    minusBtn.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, val - 1);
      updateButtons();
    });

    plusBtn.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      input.value = Math.min(10, val + 1);
      updateButtons();
    });

    input.addEventListener('change', () => {
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > 10) val = 10;
      input.value = val;
      updateButtons();
    });

    updateButtons();
  }

  /* ============================================================
     Newsletter Form
     ============================================================ */

  function initNewsletterForm() {
    const forms = document.querySelectorAll('.newsletter-form, .early-access__form');
    forms.forEach(form => {
      // Shopify handles these via form action, but we can intercept for UX
      form.addEventListener('submit', (e) => {
        const input = form.querySelector('input[type="email"]');
        if (!input || !input.value) {
          e.preventDefault();
          input && input.focus();
          return;
        }
        // Let Shopify's built-in form handling take over
        // or show loading state
        const btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Joining...';
        }
      });
    });
  }

  /* ============================================================
     Cart Page — Quantity Controls
     ============================================================ */

  function initCartPage() {
    const cartItems = document.querySelectorAll('.cart-item');
    if (!cartItems.length) return;

    cartItems.forEach(item => {
      const qtyMinus = item.querySelector('[data-qty-minus]');
      const qtyPlus = item.querySelector('[data-qty-plus]');
      const qtyDisplay = item.querySelector('.cart-item__qty-number');
      const removeBtn = item.querySelector('.cart-item__remove');
      const lineIndex = item.dataset.lineIndex;

      if (qtyMinus) {
        qtyMinus.addEventListener('click', () => {
          const current = parseInt(qtyDisplay.textContent);
          if (current <= 1) {
            updateCartLine(lineIndex, 0);
          } else {
            updateCartLine(lineIndex, current - 1);
          }
        });
      }

      if (qtyPlus) {
        qtyPlus.addEventListener('click', () => {
          const current = parseInt(qtyDisplay.textContent);
          updateCartLine(lineIndex, current + 1);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', () => {
          updateCartLine(lineIndex, 0);
        });
      }
    });
  }

  async function updateCartLine(lineIndex, quantity) {
    try {
      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: quantity })
      });
      if (res.ok) {
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
    }
  }

  /* ============================================================
     Scroll-based header transparency
     ============================================================ */

  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      if (current > 80) {
        header.style.boxShadow = '0 1px 0 rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = current;
    }, { passive: true });
  }

  /* ============================================================
     Init
     ============================================================ */

  document.addEventListener('DOMContentLoaded', () => {
    updateCartCount();
    initProductGallery();
    initVariantPicker();
    initProductForm();
    initQuickAdd();
    initAccordion();
    initSizeGuide();
    initQuantityStepper();
    initNewsletterForm();
    initCartPage();
    initHeaderScroll();
  });

})();
